import axios from "axios";
import { getUserToken } from "components/UserUtils";
import { MotherTongue } from "features/Entity/MotherTongue";
import {BASE_API_URL} from "../../app/AppConfig";

export async function getMotherTonguesRep(): Promise<MotherTongue[]>{
    try{
        const response = await axios.get<MotherTongue[]>(
            `${BASE_API_URL}/MotherTongue/GetList`,
            {headers: {Authorization: 'Bearer ' + getUserToken()}}
        );

        return response.data;
    }
    catch (err : any)
    {
        throw err;
    }
}
